<script setup>
import EmployeListItem from '@/components/employe/employe-list-item.vue'
</script>

<template>
  <v-card :color="flat ? 'white' : 'primary'" :flat="flat" class="lighten-5 h-100 w-100" rounded="xl">
    <v-card-title>
      <v-row class="mx-2" justify="space-between" align="center">
        <v-col cols="6">
          Fiche de présence
          <v-progress-circular v-if="loading" indeterminate color="secondary" />
        </v-col>
        <v-col cols="6">
          <v-row justify="end" align="center">
            <v-btn icon color="primary" @click="prevDay">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span>{{ dateProspection.format('DD MMMM YYYY') }}</span>
            <v-btn icon color="primary" @click="nextDay">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-4 h-100">
      <perfect-scrollbar v-if="!loading" class="table-container">
        <template>
          <v-list dense>
            <v-list-group :value="true" prepend-icon="mdi-human-greeting-variant">
              <template v-slot:activator>
                <v-list-item-title>
                  Présents
                  <v-chip color="secondary" class="ml-4 lighten-2">{{ fichePresence.employesPresents.length }}</v-chip>
                </v-list-item-title>
              </template>
              <employe-list-item
                v-for="e in fichePresence.employesPresents"
                :key="e.employeId"
                :employe-id="e.employeId"
                :employe-precharge="e"
              />
            </v-list-group>
            <v-list-group :value="false" prepend-icon="mdi-account-cancel">
              <template v-slot:activator>
                <v-list-item-title>
                  Abscents
                  <v-chip color="secondary" class="ml-4 lighten-2">{{ fichePresence.employesEnConges.length }}</v-chip>
                </v-list-item-title>
              </template>
              <employe-list-item
                v-for="e in fichePresence.employesEnConges"
                :key="e.employeId"
                :employe-id="e.employeId"
                :employe-precharge="e"
              />
            </v-list-group>
          </v-list>
        </template>
      </perfect-scrollbar>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'fiche-de-presence',
  props: {
    etablissementId: {
      type: Number,
      required: true,
    },
    serviceId: {
      type: Number,
      default: undefined,
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateProspection: undefined,
      loading: true,
      fichePresence: undefined,
    }
  },
  created() {
    this.dateProspection = moment()
  },
  watch: {
    etablissementId() {
      this.refresh()
    },
    dateProspection() {
      this.refresh()
    },
  },
  methods: {
    ...mapActions({
      obtenirFicheDePresenceADate: 'etablissement/obtenirFicheDePresenceADate',
    }),
    refresh() {
      this.loading = true
      this.obtenirFicheDePresenceADate({
        _etablissementId: this.etablissementId,
        _date: this.dateProspection.format('YYYY-MM-DD'),
      }).then((response) => {
        this.fichePresence = response.data
        this.loading = false
      })
    },
    prevDay() {
      this.dateProspection = moment(this.dateProspection).subtract(1, 'days')
    },
    nextDay() {
      this.dateProspection = moment(this.dateProspection).add(1, 'days')
    },
  },
}
</script>

<style scoped>
.table-container {
  height: 90% !important;
}
</style>
